import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse, inform } from "../helpers";
import { STRINGS, api, uc } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class PaymentRequest extends Mediator {
	$$paymentRequest = {
		needs: {
			allRequests: (ed, event) => this.getRequests(ed, event),
			payment: (ed, event) => this.getPayment(ed, event),
		},
	};

	$$payment = {
		completed: (ed, event) => {
			let data = eParse(ed);
			if (data.meta.get("type") != "payment-request") {
				return;
			}

			inform("Your payment completed successfully", STRINGS.SUCCESS);
		},
	};

	$$user = {
		authenticated: (ed, event) =>
			this.send($e.paymentRequest.needs.allRequests),
		loggedOut: () => this.setRequests(),
	};

	async getRequests(ed, event) {
		let res = await api.get(`${routes.paymentRequests}`, { page: 1, interval: 1000 });

		if (!res) {
			this.setRequests();
			return;
		}

		this.setRequests(res.data.paymentRequests.data);

		this.send($e.paymentRequest.has.allRequests);
	}

	setRequests(req = {}) {
		uc.paymentRequests.value = req;
	}

	getPayment(ed, event) {
		let data = eParse(ed);

		if (data.message.get("request", null) == null) {
			inform("Invalid request", STRINGS.ERROR);
			app("router").to("/");
			return;
		}

		let request = data.message.get("request");

		data.meta.put("route", `${routes.paymentRequests}/${request?.id}/pay`);

		data.meta.put("type", "payment-request");
		data.meta.put("typeId", request?.id);
		data.message.put("amount", request?.amount);

		if (data.message.has("next")) {
			data.meta.put("next", data.message.get("next"));
		}

		this.broadcast(
			$e.payment.needs.collection,
			payload(data.message, data.meta)
		);
	}
}
